import Raven from 'raven-js';

/**
 * Verify that a function is being called from the client.
 */
function verifyClient() {
  if (!__CLIENT__) {
    // Capture and rethrow error.
    Raven.context(() => {
      throw new Error(
        '[utils/ipstack] Attempted to get user location from non-client source',
      );
    });
  }
}

/**
 * Get information based on the current users IP Address.
 * Documentation: https://ipstack.com/documentation
 */
export async function sendIpstackRequest() {
  try {
    const result = await fetch(
      `https://api.ipstack.com/check?access_key=${IPSTACK_API_KEY}`,
      {
        timeout: 500,
      },
    );
    if (result) {
      return await result.json();
    }
  } catch (e) {
    Raven.captureException(e);
  }
  // Location data could not be loaded for the provided ip.
  return {};
}

/**
 * Extracts the information used by Segment to group user location data.
 * Documentation: https://segment.com/docs/spec/common/#context
 *
 * Speed is not included, but an additional zipcode field is added for analytics.
 *
 * @param ipstack - json response from sendIpstackRequest()
 */
function extractSegmentLocationInfo(ipstackInfo) {
  return {
    country: ipstackInfo.country_name,
    countrycode: ipstackInfo.country_code,
    region: ipstackInfo.region_name,
    city: ipstackInfo.city,
    zipcode: ipstackInfo.zip,
    latitude: ipstackInfo.latitude,
    longitude: ipstackInfo.longitude,
  };
}

/**
 * Gets the location information used by Segment for the current users IP.
 */
export async function getLocationInfoForCurrentUser() {
  // Function should only be called from the client.
  verifyClient();

  const ipstackInfo = await sendIpstackRequest();
  return extractSegmentLocationInfo(ipstackInfo);
}
